import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth uses an httpOnly session cookie — no tokens in localStorage (XSS-safe).
// withCredentials only when the API is same-origin: cross-origin credentialed requests
// get blocked by proxies that force 'Access-Control-Allow-Origin: *' (mobile "Network Error").
let sameOrigin = true;
try {
  sameOrigin = new URL(API, window.location.href).origin === window.location.origin;
} catch (e) {
  console.debug("api: could not derive origin, defaulting sameOrigin=true", e);
}
const api = axios.create({ baseURL: API, withCredentials: sameOrigin });

// Read the double-submit CSRF cookie the backend sets on /auth/login and /auth/me.
// document.cookie only surfaces cookies without HttpOnly; the access_token is HttpOnly
// and never touches JS. If we can't find it we skip the header (unauth requests or the
// first login POST — both are CSRF-exempt on the server).
function readCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[1]) : null;
}

// No-op kept for backward compatibility with older imports; auth is now cookie-only.
export const setAuthToken = () => {};

const MUTATING = new Set(["post", "put", "patch", "delete"]);

api.interceptors.request.use((cfg) => {
  const method = (cfg.method || "get").toLowerCase();
  if (MUTATING.has(method)) {
    const csrf = readCookie("csrf_token");
    if (csrf) cfg.headers["X-CSRF-Token"] = csrf;
  }
  return cfg;
});

export function apiErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && d.msg ? d.msg : JSON.stringify(d))).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}

export { API };
export default api;
